export default __webpack_public_path__ + "static/media/cantilevertransparent.f368fcf7.png";